/* EcoSparkle Home — Safe Landing Page JS */

/* ── Add to cart with source tracking ── */
async function addStarterToCart() {
  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{
          id: STARTER_VARIANT_ID,
          quantity: 1,
          properties: { '_source': 'safe-landing' }
        }]
      })
    });
    if (res.ok) {
      if (window.gtag) gtag('event', 'add_to_cart', { value: 300, currency: 'ILS', source: 'safe' });
      if (window.fbq)  fbq('track', 'AddToCart', { value: 300, currency: 'ILS' });
      window.location.href = '/checkout';
    } else {
      const err = await res.json();
      alert(err.description || 'משהו השתבש. נסו שוב.');
    }
  } catch (e) {
    alert('שגיאת רשת. בדקו חיבור לאינטרנט ונסו שוב.');
  }
}

/* ── Countdown (resets daily at midnight) ── */
(function initCountdown() {
  function getTarget() {
    const t = new Date();
    t.setHours(23, 59, 59, 999);
    return t;
  }
  let target = getTarget();
  function tick() {
    const diff = target - Date.now();
    if (diff <= 0) target = getTarget();
    const pad = n => String(Math.max(0, n)).padStart(2, '0');
    const h = document.getElementById('cntH');
    const m = document.getElementById('cntM');
    const s = document.getElementById('cntS');
    if (h) h.textContent = pad(Math.floor(diff / 3600000));
    if (m) m.textContent = pad(Math.floor((diff % 3600000) / 60000));
    if (s) s.textContent = pad(Math.floor((diff % 60000) / 1000));
  }
  tick();
  setInterval(tick, 1000);
})();

/* ── Sticky CTA ── */
(function initStickyCta() {
  const el = document.getElementById('stickyCta');
  if (!el) return;
  let ticking = false;
  window.addEventListener('scroll', function () {
    if (!ticking) {
      requestAnimationFrame(function () {
        const show = window.scrollY > 800;
        el.classList.toggle('visible', show);
        el.setAttribute('aria-hidden', String(!show));
        ticking = false;
      });
      ticking = true;
    }
  }, { passive: true });
})();

/* ── FAQ accordion ── */
(function initFaq() {
  document.querySelectorAll('.faq-q').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const expanded = btn.getAttribute('aria-expanded') === 'true';
      document.querySelectorAll('.faq-q[aria-expanded="true"]').forEach(function (other) {
        if (other !== btn) {
          other.setAttribute('aria-expanded', 'false');
          other.nextElementSibling.hidden = true;
        }
      });
      btn.setAttribute('aria-expanded', String(!expanded));
      btn.nextElementSibling.hidden = expanded;
    });
  });
})();

/* ── Intersection observer fade-in ── */
(function initFadeIn() {
  const sections = document.querySelectorAll('.fade-in-section');
  if (!('IntersectionObserver' in window)) {
    sections.forEach(function (s) { s.classList.add('visible'); });
    return;
  }
  const obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('visible'); obs.unobserve(e.target); }
    });
  }, { threshold: 0.08 });
  sections.forEach(function (s) { obs.observe(s); });
})();

/* ── UGC carousel drag scroll ── */
(function initCarousel() {
  const track = document.querySelector('.ugc-carousel');
  if (!track) return;
  let isDown = false, startX = 0, scrollLeft = 0;
  track.addEventListener('mousedown', function (e) {
    isDown = true; track.style.cursor = 'grabbing';
    startX = e.pageX - track.offsetLeft; scrollLeft = track.scrollLeft;
  });
  track.addEventListener('mouseleave', function () { isDown = false; track.style.cursor = 'grab'; });
  track.addEventListener('mouseup',    function () { isDown = false; track.style.cursor = 'grab'; });
  track.addEventListener('mousemove',  function (e) {
    if (!isDown) return;
    e.preventDefault();
    track.scrollLeft = scrollLeft - (e.pageX - track.offsetLeft - startX) * 1.5;
  });
})();

/* ── Smooth scroll anchors ── */
document.querySelectorAll('a[href^="#"]').forEach(function (a) {
  a.addEventListener('click', function (e) {
    const target = document.querySelector(a.getAttribute('href'));
    if (target) { e.preventDefault(); target.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
  });
});
